import React, { useState, useRef, useEffect } from "react";
import styled from "styled-components";

export default function FrequencyBox(props) {
  const { data } = props;

  const TotalWidth = 445;

  const [lessonNameBoxWidth, setLessonNameBoxWidth] = useState(270);
  const [reserveResultBoxWidth, setReserveResultBoxWidth] = useState(94);

  const lessonNameBoxRef = useRef(null);
  const reserveResultBoxRef = useRef(null);

  useEffect(() => {
    setLessonNameBoxWidth(lessonNameBoxRef.current?.offsetWidth ?? 270);
    setReserveResultBoxWidth(reserveResultBoxRef.current?.offsetWidth ?? 94);
  }, [data]);

  // 시간 정리 //
  function calcLessonClassTime() {
    let tmp = data.classTime.split('-');
    let splitTmp = tmp[0].split(':');
    let splitTmp2 = tmp[1].split(':');
    let startTime = '';
    let endTime = '';

    if (parseInt(splitTmp[0]) > 12) startTime = (parseInt(splitTmp[0]) - 12) + ':' + splitTmp[1] + ' PM';
    else startTime = splitTmp[0] + ':' + splitTmp[1] + ' AM';

    if (parseInt(splitTmp2[0]) > 12) endTime = (parseInt(splitTmp2[0]) - 12) + ':' + splitTmp2[1] + ' PM';
    else endTime = splitTmp2[0] + ':' + splitTmp2[1] + ' AM';

    return startTime + ' - ' + endTime + ' : ' + data.teacherNames;
  }

  // 구분선 길이 정리 //
  function decideDivisionLineWidth() {
    return TotalWidth - (lessonNameBoxWidth + reserveResultBoxWidth + 20);
  }

  return (
    <TopLevelWrapper width={TotalWidth}>
      <Text fontFamily='Poppins-Medium' fontSize={12} color='#777777' cursor='default'>{calcLessonClassTime()}</Text>
      <InnerComponentWrapper>
        <LessonNameBox ref={lessonNameBoxRef} backgroundColor={data.color}>
          <LessonNameWrapper>
            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' cursor='default'>{data.lessonName}</Text>
          </LessonNameWrapper>
        </LessonNameBox>
        <DivisionLine width={decideDivisionLineWidth()}/>
        <ReserveResultBox ref={reserveResultBoxRef}>
          <ReserveResultTextWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' cursor='default'>{'총 ' + data.reserveCount + '명 수강'}</Text>
          </ReserveResultTextWrapper>
        </ReserveResultBox>
      </InnerComponentWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;

  gap: 4px;
`;

const InnerComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const LessonNameBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  min-width: 126px;
  max-width: 250px;
  height: 28px;

  border-radius: 4px;
  background-color: ${props => props.backgroundColor}
`;

const LessonNameWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 20px;
  
  overflow: hidden;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  width: ${props => props.width}px;
  height: 1px;

  background-color: #ECECEC;
`;

const ReserveResultBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px;

  min-width: 74px;
  height: 28px;

  border-radius: 4px;
  background-color: #ECECEC;
`;

const ReserveResultTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 28px;

  border-radius: 8px;
  background-color: #ECECEC;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;
